import BigNumber from 'bignumber.js';
import { VrtToken, BrnToken, Erc20, BaiToken } from 'types/contracts';

export interface IGetBalanceOfInput {
  tokenContract: VrtToken | BrnToken | Erc20 | BaiToken;
  accountAddress: string;
}

export type GetBalanceOfOutput = BigNumber;

const getBalanceOf = async ({
  tokenContract,
  accountAddress,
}: IGetBalanceOfInput): Promise<GetBalanceOfOutput> => {
  const resp = await tokenContract.methods.balanceOf(accountAddress).call();
  return new BigNumber(resp);
};

export default getBalanceOf;
